import PropTypes from "prop-types";
import React from "react";
import { Row, Col } from "react-bootstrap";
import {
  FaBolt,
  FaCog,
  FaEnvelope,
  FaImages,
  FaLink,
  FaTags,
  FaVideo,
} from "react-icons/fa";
import { FaMessage, FaPencil, FaTabletScreenButton } from "react-icons/fa6";
import { useDispatch } from "react-redux";

import QuickMenu from "../components/menu/QuickMenu.jsx";
import { hasPermissions } from "../store/thunks.js";

const menuItems = [
  {
    link: "/arrivideo",
    name: "arriVideo",
    icon: <FaVideo size={18} />,
    resourceType: "ARRIVIDEO",
    resourceKey: "isAdministrator",
  },
  {
    link: "/tablet-registration",
    name: "tabletRegistration",
    icon: <FaTabletScreenButton size={18} />,
    resourceType: "TABLET_REGISTRATION",
    resourceKey: "isAdministrator",
  },
  {
    link: "/url-entry",
    name: "urlEntry",
    icon: <FaLink size={18} />,
    resourceType: "URLENTRY",
    resourceKey: "isAdministrator",
  },
  {
    link: "/software-package",
    name: "softwarePackage",
    icon: <FaTags size={18} />,
    resourceType: "SOFTWARE_PACKAGE",
    resourceKey: "isAdministrator",
  },
  {
    link: "/message",
    name: "notifications",
    icon: <FaEnvelope size={18} />,
    resourceType: "SOFTWARE_PACKAGE",
    resourceKey: "isAdministrator",
  },
  {
    link: "/malfunction-form",
    name: "malfunctions",
    icon: <FaBolt size={18} />,
    resourceType: "MALFUNCTIONS",
    resourceKey: "isAdministrator",
  },
  {
    link: "/email-establishment",
    name: "establishments",
    icon: <FaPencil size={18} />,
    resourceType: "EMAIL_ESTABLISHMENT",
    resourceKey: "isAdministrator",
  },
  {
    link: "/notifications",
    name: "usersNotifications",
    icon: <FaMessage size={18} />,
    resourceType: "USER_NOTIFICATIONS",
    resourceKey: "isAdministrator",
  },
  {
    link: "/signal-image",
    name: "signalImages",
    icon: <FaImages size={18} />,
    resourceType: "MACHINIST",
    resourceKey: "isTrainStopSignalImageAdministrator",
  },
  {
    link: "/settings",
    name: "settings",
    icon: <FaCog size={18} />,
    resourceType: "SETTINGS",
    resourceKey: "isAdministrator",
  },
];

const BaseLayout = ({
  childComponent: ChildComponent,
  childProps,
  ...additionalProps
}) => {
  const dispatch = useDispatch();

  // Filter menu items based on drive permissions.
  const authorizedMenuItems = menuItems.filter((item) =>
    dispatch(hasPermissions(item.resourceType, item.resourceKey)),
  );

  if (authorizedMenuItems.length === 0) return null;

  return (
    <Row>
      <Col sm={3} md={4} lg={2} className="hidden-print sidebar-left">
        <QuickMenu menuItems={authorizedMenuItems} />
      </Col>

      {ChildComponent && (
        <Col
          sm={{ span: 10, order: 0 }}
          md={{ span: 10, order: 0 }}
          lg={{ span: 10, order: 0 }}
        >
          <ChildComponent {...childProps} {...additionalProps} />
        </Col>
      )}
    </Row>
  );
};

BaseLayout.propTypes = {
  childComponent: PropTypes.oneOfType([PropTypes.elementType, PropTypes.func]),
  childProps: PropTypes.object,
};

export default BaseLayout;
